module.exports = __webpack_public_path__ + "static/media/Discover.9e60a0b5.png";